module.exports = __webpack_public_path__ + "media/images/head-7b6402ee1c7751a965b75bf7e691b1f2.png";